import { getAuth, signOut } from 'firebase/auth';
import { getFirestore, setDoc, doc } from "firebase/firestore";
import { app } from '../credenciales';
import QRCode from "qrcode";

const db = getFirestore(app);
const auth = getAuth();

export const logOut = async()=>{
  try {
    await signOut(auth);
    sessionStorage.clear();
  } catch (error) {
    console.error("Error al cerrar sesión:", error);
  }
}

export const formatDate = (date)=>{
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Mes comienza en 0
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}

export const formatShortDate = (date) =>{
  const [year, month, day] = date.split("-");
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}

export const generateQrCode = async(data) =>{
try {
    const qrCodeData = await QRCode.toDataURL(data);
    return qrCodeData;
  } catch (error) {
    console.error("Error generating QR code: ", error);
  }
}

export const sendUserToFirestore = async(email, name, lastName, numeroSocio, fechaNacimiento, role, qrCodeURL)=>{
  const nuevoUsuario = {
    email: email,
    name: name,
    lastName: lastName,
    numeroSocio: numeroSocio,
    fechaNacimiento: fechaNacimiento,
    role: role,
    qrCodeURL: qrCodeURL,
    estado: false,
  };

  await setDoc(doc(db, "usuarios", email), { ...nuevoUsuario, qrCodeURL });
}